import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";

export const zona: AnaColumn[] = [

  {
    itemType: "group", colCount: "1", data: [
      {
        type: 'campo',
        dataField: 'index',
        dataType: '',
        caption: ' ',
        width: 20,
        allowEditing: false,
        showEditorAlways: false,
      },
      { type: 'campo', colVisible: true, dataField: "id", dataType: "", caption: "Codice", colWidth: "20px", showEditorAlways: false },
      { type: 'campo', colVisible: true, dataField: "descrizione", dataType: "", caption: "Descrizione", maxSize: 255, maxLength: '255', colWidth: "200px" },


      {
        type: 'campo', colVisible: false, dataField: "nomeTabella", dataType: "", hideOnEdit: false,

        allowEditing: false,
        showEditorAlways: false,


      },
    ]
  },
]